import moment from 'moment-timezone'
import { currencySymbol } from 'cogsworth/utils/currencies'
import { prettyTimezone } from 'cogsworth/utils/dates'
const sanitizeHtml = require('sanitize-html')

export const injectValuesIntoTemplate = (template, { service, booking, dateFormat, payOnArrival, visibleFields=[], coupon }) => {
  let rePattern = /\{\{(.+?)\}\}/gi

  let content = template.replace(rePattern, (match, value, urlId) => {
    switch(value) {
      case 'service-name': return getServiceNameHtml(service, visibleFields)
      case 'booking-duration-minutes': return getDurationHtml(booking, visibleFields)
      case 'booking-location': return getBookingLocation(booking, visibleFields)
      case 'service-location': return getBookingLocation(booking, visibleFields) // Keep this one for backward-compatibility
      case 'booking-price': return getBookingPrice({ service, booking, payOnArrival, coupon })
      case 'booking-time-start': return `<nav data-field="booking_date">${moment.tz(booking.date, booking.clientTimezone).format(dateFormat.time)}</nav>`
      case 'booking-time-end': return `<nav data-field="booking_date">${moment.tz(booking.date, booking.clientTimezone).add(booking.duration, 'minutes').format(dateFormat.time)}</nav>`
      case 'booking-date': return `<nav data-field="booking_date">${moment(booking.date).format(dateFormat.date)}</nav>`
      case 'customer-name': return booking.customer ? booking.customer.name : booking.customerName
      case 'customer-email': return booking.customer ? booking.customer.email : booking.customerEmail
      case 'customer-phone': return booking.customer ? booking.customer.phoneMobile : booking.customerPhone
      case 'customer-timezone': return prettyTimezone(booking.clientTimezone)
      case 'hangouts-link': return booking.hangoutLink ? booking.hangoutLink : '{{remove-line}}'
      default: return getCustomAnswer(value, booking)
    }
  })

  // Remove paragraphs containing the {{remove-line}} string
  content = content.replace(/<p>.*\{\{remove-line\}\}.*<\/p>/gi, "")
  content = content.replace("{{remove-line}}", "")

  // Remove line breaks
  content = content.replace('\n', '')

  return sanitizeHtml(content, {
    allowedTags: [ 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol', 'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div', 'caption', 'pre', 'nav', 'span', 'img' ],
    allowedAttributes: {
      a: ['href', 'target'],
      nav: ['data-field'],
      span: ['class'],
      img: ['src']
    }
  })
}

const getCustomAnswer = (placeholder, booking) => {
  const id = placeholder.replaceAll('<em>', '_').replaceAll('</em>', '_').replace('_answer', '')
  const fields = booking.answers || []
  const field = fields.find((field) => field.id === id)
  if (!field) {
    return ''
  }

  return field.answer
}

const getServiceNameHtml = (service, visibleFields) => {
  if (visibleFields.indexOf('booking_service') > -1) {
    return `<nav data-field="booking_service">${service.name}</nav>`
  }

  return `<nav>${service.name}</nav>`
}

const getDurationHtml = (booking, visibleFields) => {
  if (visibleFields.indexOf('booking_duration') > -1) {
    return `<nav data-field="booking_duration">${booking.duration}</nav>`
  }

  return `<nav>${booking.duration}</nav>`
}


const getBookingPrice = ({ service, booking, payOnArrival, coupon }) => {
  const duration = service.durations && service.durations.find(d => d.duration === booking.duration)
  if(!duration || duration.price === 0) {
    return '{{remove-line}}'
  }

  const regularPrice = currencySymbol(service.currency) + duration.price

  if (coupon) {
    const discountedPrice = currencySymbol(coupon.currency) + coupon.price
    return `<span class="strikethrough">${regularPrice}</span><span>${discountedPrice}</span>`
  }

  return regularPrice
}

const getBookingLocation = (booking, visibleFields) => {
  let location = '{{remove-line}}'

  if (booking.location) location = booking.location
  if (booking.locationValue) location = booking.locationValue

  if (location !== '{{remove-line}}' && visibleFields.indexOf('booking_location') > -1) {
    return `<nav data-field="booking_location">${location}</nav>`
  }

  return location
}
